import EventActionProto from '../event-action-proto';

module.exports = class WorkScheduleAccessReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
    }

    validate() {
        return true;
    }

    process() {
        gd.session.workScheduleAccess.reset(this.data,{parse:true});
    }
};


